import React, { SetStateAction } from 'react';
import { LogbookDataEntry } from './LogbookOverview';
import {
	AccessorKeyColumnDef,
	getCoreRowModel,
	PaginationState,
	useReactTable,
	Table as __Table,
} from '@tanstack/react-table';
import { Table as BTable } from 'react-bootstrap';
import * as ROUTES from '../../../constants/routes';
import { useNavigate } from 'react-router-dom';
import TableFooter from '../Components/TableFooter';
import TableBody from '../Components/TableBody';
import TableHeader from '../Components/TableHeader';

type Props = {
	columns: AccessorKeyColumnDef<LogbookDataEntry, unknown>[];
	data: LogbookDataEntry[];
	pagination: PaginationState;
	setPagination: React.Dispatch<SetStateAction<PaginationState>>;
	totalItems: number;
};

const Table = ({ data, columns, pagination, setPagination, totalItems }: Props) => {
	const navigate = useNavigate();

	const table = useReactTable({
		data,
		columns,
		getCoreRowModel: getCoreRowModel(),
		onPaginationChange: setPagination,
		state: {
			pagination,
		},
		enableSorting: false,
		rowCount: totalItems,
		manualPagination: true,
	});
	return (
		<>
			<div className="d-flex justify-content-end"></div>
			<BTable responsive hover size={'l'}>
				<TableHeader table={table as __Table<unknown>} />
				<TableBody
					table={table as __Table<unknown>}
					handleRowClick={(row) => navigate(ROUTES.logbookEntryDetailPage(row.id))}
				/>
			</BTable>
			<TableFooter table={table as __Table<unknown>} />
		</>
	);
};

export default Table;
